import React from 'react';
import { Box, Typography, Container, Paper } from '@mui/material';
import ConstructionIcon from '@mui/icons-material/Construction';
import { endDate, maintenanceEmail } from '../../maintenance';
import { endTime } from '../../maintenance';

const Maintenance: React.FC = () => {
  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Paper
          elevation={3}
          sx={{
            p: 4,
            textAlign: 'center',
            borderRadius: 2,
          }}
        >
          <ConstructionIcon sx={{ fontSize: 60, color: 'primary.main', mb: 2 }} />
          <Typography variant="h4" component="h1" gutterBottom>
            We'll Be Right Back
          </Typography>
          <Typography variant="h6" color="text.secondary" gutterBottom>
            Scheduled Maintenance in Progress
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mt: 2 }}>
            We're currently performing scheduled maintenance to improve your experience.
            We expect to be back online by {endDate} at {endTime}.
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
            Thank you for your patience.
          </Typography>
          {maintenanceEmail && <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
            If you have any questions, please contact <a href={`mailto:${maintenanceEmail}`}>{maintenanceEmail}</a>.
          </Typography>}
        </Paper>
      </Box>
    </Container>
  );
};

export default Maintenance; 